import React, { SVGProps } from 'react'

export const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={17}
    height={17}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.66667 0C2.99266 0 0 2.99266 0 6.66667C0 10.3407 2.99266 13.3333 6.66667 13.3333C8.26434 13.3333 9.73159 12.766 10.8815 11.8242L14.862 15.8047C14.9234 15.8687 14.997 15.9198 15.0784 15.9549C15.1598 15.9901 15.2474 16.0087 15.3361 16.0096C15.4248 16.0105 15.5128 15.9937 15.5949 15.9602C15.6771 15.9267 15.7517 15.8771 15.8144 15.8144C15.8771 15.7517 15.9267 15.6771 15.9602 15.5949C15.9937 15.5128 16.0105 15.4248 16.0096 15.3361C16.0087 15.2474 15.9901 15.1598 15.9549 15.0784C15.9198 14.997 15.8687 14.9234 15.8047 14.862L11.8242 10.8815C12.766 9.73159 13.3333 8.26434 13.3333 6.66667C13.3333 2.99266 10.3407 0 6.66667 0ZM6.66667 1.33333C9.62008 1.33333 12 3.71325 12 6.66667C12 9.62008 9.62008 12 6.66667 12C3.71325 12 1.33333 9.62008 1.33333 6.66667C1.33333 3.71325 3.71325 1.33333 6.66667 1.33333Z"
      fill={props.color || '#333333'}
    />
  </svg>
)

export const UserIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={15}
    height={16}
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.49966 0.5C5.29033 0.5 3.49966 2.29067 3.49966 4.5V5.16667C3.49966 7.376 5.29033 9.16667 7.49966 9.16667C9.709 9.16667 11.4997 7.376 11.4997 5.16667V4.5C11.4997 2.29067 9.709 0.5 7.49966 0.5ZM7.49836 11.1667C4.82769 11.1667 1.40103 12.6112 0.415028 13.8932C-0.194306 14.6859 0.385747 15.8333 1.38508 15.8333H13.6129C14.6123 15.8333 15.1923 14.6859 14.583 13.8932C13.597 12.6119 10.169 11.1667 7.49836 11.1667Z"
      fill={props.color || '#333333'}
    />
  </svg>
)

export const FacilityIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={15}
    height={16}
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 0.000488281L7.03939 0.30485L0 4.96956V14.3332C0 15.2441 0.755781 15.9998 1.66667 15.9998H13.3333C14.2442 15.9998 15 15.2441 15 14.3332V4.96956L7.5 0.000488281ZM7.5 1.99919L13.3333 5.86475V14.3332H1.66667V5.86475L7.5 1.99919ZM6.66667 5.99984V8.49984H4.16667V10.1665H6.66667V12.6665H8.33333V10.1665H10.8333V8.49984H8.33333V5.99984H6.66667Z"
      fill={props.color || '#333333'}
    />
  </svg>
)

export const LocationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.99967 0.333496C6.05434 0.333496 3.66634 2.7215 3.66634 5.66683C3.66634 9.66683 8.33301 11.0002 8.33301 13.6668C8.33301 14.0348 8.63167 14.3335 8.99967 14.3335C9.36767 14.3335 9.66634 14.0348 9.66634 13.6668C9.66634 11.0002 14.333 9.66683 14.333 5.66683C14.333 2.7215 11.945 0.333496 8.99967 0.333496ZM8.99967 4.3335C9.73634 4.3335 10.333 4.93016 10.333 5.66683C10.333 6.4035 9.73634 7.00016 8.99967 7.00016C8.26301 7.00016 7.66634 6.4035 7.66634 5.66683C7.66634 4.93016 8.26301 4.3335 8.99967 4.3335ZM5.25358 11.3048C2.48358 11.7782 0.333008 12.7975 0.333008 14.3335C0.333008 16.5215 4.69301 17.6668 8.99967 17.6668C13.3063 17.6668 17.6663 16.5215 17.6663 14.3335C17.6663 12.7975 15.5158 11.7782 12.7458 11.3048C12.6918 11.3588 12.637 11.4123 12.583 11.465C12.2183 11.8243 11.8791 12.1619 11.6064 12.4819C14.6811 12.8439 16.333 13.7922 16.333 14.3335C16.333 15.0128 13.7443 16.3335 8.99967 16.3335C4.25501 16.3335 1.66634 15.0128 1.66634 14.3335C1.66634 13.7922 3.31824 12.8439 6.3929 12.4819C6.11957 12.1619 5.78034 11.8243 5.41634 11.465C5.36301 11.4123 5.30825 11.3588 5.25358 11.3048Z"
      fill={props.color || '#333333'}
    />
  </svg>
)
